var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('promo-transition',[_c('div',{staticClass:"pd-top-15"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-breadcrumbs',{staticClass:"fadeIn breadcrumb",attrs:{"items":[
        {
          text: this.$t('navDrawer.home').toUpperCase(),
          disabled: false,
          to: {name: 'home'},
          exact: true
        },
        {
          text: _vm.$t('m_chat'),
          disabled: false,
          to: {name: 'chat'},
          exact: true
        }
      ]}},[_c('v-icon',{attrs:{"slot":"divider"},slot:"divider"},[_vm._v("chevron_right")])],1),_c('v-container',{staticClass:"paddingSecondContainer",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"wrap":"","pt-3":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('lista-chats',{ref:"listaChats"})],1),_c('v-flex',{attrs:{"md10":""}},[_c('div',{staticClass:"chat-container lg12"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"table"},[_c('chat-header',{attrs:{"titulo":this.titulo,"idIncidencia":this.idIncidencia}}),_c('chat-log',{ref:"chatlog",attrs:{"idIncidencia2":this.idIncidencia}}),_c('message-input',{attrs:{"detalleIncidencia":this.incidenciaActual,"idIncidencia":this.idIncidencia},on:{"recargar":function($event){return _vm.recargar()}}})],1)])])])],1)],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }